import i18n from "@/i18ns/i18n.js";
import PlatformFunctionBase from "./PLatFormFunctionBase";

let platform = new PlatformFunctionBase();

export const handleLocalize = (key) => {
  if (key && key.includes("i18n")) {
    return i18n.tc(`${key}`);
  }
  return key;
};

/**
 * Hàm chọn value dựa trên ngôn ngữ hiện tại
 * created by pdthien
 * @param {*} viValue
 * @param {*} enValue
 * @returns
 */
export const handleValueLocalize = (viValue, enValue) => {
  if (platform.getAppLanguage("vi") == "vi" || !enValue) {
    return viValue;
  }
  return enValue;
};

/**
 * Hàm chọn trường hiển thị dựa trên ngôn ngữ hiện tại
 * created by cvcuong1
 * @param {*} viField
 * @returns
 */
export const handleFieldLocalize = (viField) => {
  if (platform.getAppLanguage("vi") == "vi") {
    return viField;
  }
  return viField + "_EN";
};
